import { render, staticRenderFns } from "./WenXun.vue?vue&type=template&id=395035e6&scoped=true"
import script from "./WenXun.vue?vue&type=script&lang=js"
export * from "./WenXun.vue?vue&type=script&lang=js"
import style0 from "./WenXun.vue?vue&type=style&index=0&id=395035e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395035e6",
  null
  
)

export default component.exports